"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MatchHistoryLayout_1 = __importDefault(require("@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryLayout"));
const MatchHistoryRecordingGroups_1 = __importDefault(require("@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryRecordingGroups"));
const MatchHistoryViewSubmission_1 = __importDefault(require("@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryViewSubmission"));
const MatchHistorySearch_1 = __importDefault(require("@Scenes/RightsholderScene/MatchHistory/v2/MatchHistorySearch"));
const route_1 = require("@App/navigation/route");
const createMatchHistoryRoutes = () => ({
    path: '',
    element: react_1.default.createElement(MatchHistoryLayout_1.default, null),
    children: [
        {
            path: route_1.RIGHTSHOLDER_SUB_ROUTES.matchHistory.recording,
            element: react_1.default.createElement(MatchHistoryRecordingGroups_1.default, null),
        },
        {
            path: route_1.RIGHTSHOLDER_SUB_ROUTES.matchHistory.submission,
            element: react_1.default.createElement(MatchHistoryViewSubmission_1.default, null),
        },
        {
            path: route_1.RIGHTSHOLDER_SUB_ROUTES.matchHistory.root,
            element: react_1.default.createElement(MatchHistorySearch_1.default, null),
        },
    ],
});
exports.default = createMatchHistoryRoutes;
